import { bl_fi_my_einvoice_single_general_pool_doc_hdr_RowClass } from '../../dbschema/bl_fi_my_einvoice_single_general_pool_doc_hdr.model';

import { BaseContainerModel } from '../base-container.model';

export class MyEInvoiceSingleGeneralPoolDocHdrContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_single_general_pool_doc_hdr: bl_fi_my_einvoice_single_general_pool_doc_hdr_RowClass = new bl_fi_my_einvoice_single_general_pool_doc_hdr_RowClass();
}
